module.exports = __webpack_public_path__ + "static/media/cobreFacil.05394989.svg";